import React, { useEffect, useRef, useState } from 'react'
import "./style.scss"
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig'
import Logo from '../../assets/images/logo/nh-logo.png'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption'
import { Base_API } from '../../_actions/matcher'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import SignIn_Navbar from '../../components/SignIn_Navbar'
import { NhealthAction } from '../../_actions/action.api'

function SignIn_Policy() {
    let onceMount = useRef(true);

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    }, [])

    const pageInit = async() => {
        // (Check came from URL and then check if re-load or not) เพิ่อรีเซท state ของ dom ที่ค้างอยู่เช่น checkbox confirm ถ้ากดกลับจากหน้าอื่นมาหน้านี้ state จะโชว์ว่า checked อยู่แต่ในระบบจริิงๆแล้ว state ของ checkbox ไม่ได้ถูกเซท คือการแก้บัคการแสดงผลนั่นเอง

        // let jwt = await JWTAuthen();
        // let userRes = await checkUser(jwt);

        await checkCurrentURL(); 
        isPageLoading(false);
    }

    const JWTAuthen = () => {
        return new Promise(async resolve => {
            let ip = await NhealthAction.GetIPAdress();

            let reqData = {
                UserRef: "Uccf0390b0387fefca9629095f30615a1",
                IPAddress: ip,
                Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
            } 

            NhealthAction.JWT_Authen(reqData)
            .then(res => {
                console.log('JWT: ', res);
                if(!!res)
                {
                    resolve(res);
                }
            })
        })
    }
    const checkUser = (jwt) => {
        return new Promise(async resolve => {
            let reqData = {
                "data": EncryptedText('0958129601')
            }
            let headers = {
                headers: {
                    Authorization: `Bearer ${jwt.token}`,
                    userRef: 'Uccf0390b0387fefca9629095f30615a1',
                    authorizeRef: jwt.authorizeRef,
                    channalRef: jwt.channalRef
                }
            }
            NhealthAction.SignInPhone(reqData, headers)
            .then(res => {
                console.log(res);
                if(res.IsSuccess) 
                {
                    resolve(res);
                }else
                {
                    // show alert
                }
            })
        })
    }


    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let enc_currentpage_url = localStorage.getItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL)
            let pathname = location.pathname;

            if(!!enc_currentpage_url)
            {
                let dec_currentpage_url = DecryptedText(enc_currentpage_url);
                if(pathname !== dec_currentpage_url)
                {
                    // set new
                    localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
                    // navigate
                    location.reload();
                }
            }else
            {
                // set new
                localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
            }
            resolve();
        })
    }

    const onChange = (e) => {
        setChecked(!checked);
    } 

    const onSubmit = async() => {
        if(checked)
        {
            localStorage.setItem(process.env.REACT_APP_ENC_NAME_ACCEPT_SIGNIN_POLICY, EncryptedText('true')); 
            nextPage();
        }
    }
    const nextPage = () => {
        let enc_camefrom_url = localStorage.getItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL);
        if(!!enc_camefrom_url)
        {
            let dec_camefrom_url = DecryptedText(enc_camefrom_url);
            let cameFromURL = String(dec_camefrom_url.replace(Base_API.pathWeb, "")).toLowerCase();

            switch(cameFromURL)
            {
                case `/n-health/signin/overview`|| `/n-health/signin/overview/`
                :
                    location.href = `${Base_API.pathWeb}/n-health/signup/privacy-policy`;    
                    // location.href = `${Base_API.pathWeb}/n-health/signup/overview`;
                    break;
                ;
                case `/n-health/signin/privacy-policy`|| `/n-health/signin/privacy-policy/`
                :
                    // location.href = `${Base_API.pathWeb}/n-health/signin/privacy-policy`;    
                    location.href = `${Base_API.pathWeb}/n-health/signup/overview`;
                    break;
                ;
                default:
                    location.href = `${Base_API.pathWeb}/n-health/signin/connection`;
                    break;    
                ;
            }
        }else
        {
            location.href = `${Base_API.pathWeb}/n-health/signin/connection`;
        }
    }

    return (
        <div className="signin-policy-con">
            <img src={Logo} className='logo' />
            <h1 className='title'>
                เงื่อนไขการใช้บริการ
            </h1>
            <p className='desc'>
                บริษัท เนชั่นแนล เฮลท์แคร์ ซิสเท็มส์ (N Health) (“บริษัท”) ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคล และในฐานะที่บริษัทเป็นผู้ควบคุมข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 บริษัทมีหน้าที่ตามกฎหมายในการแจ้งเอกสารฉบับนี้ให้ท่านทราบถึงเหตุผลและวิธีการที่บริษัทเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน รวมถึงแจ้งให้ท่านทราบสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
                1. คำนิยาม
                “ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลส่วนบุคคลของคนที่มีชีวิตอยู่ที่สามารถระบุตัวตนของบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม “ข้อมูลส่วนบุคคลที่อ่อนไหว” หมายถึง ข้อมูลส่วนบุคคลที่เกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ (เช่น ข้อมูลภาพจำลองใบหน้า ข้อมูลจำลองม่านตา ข้อมูลจำลองลายนิ้วมือ) หรือข้อมูลอื่นใดที่กระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด “ประมวลผล” หมายถึง เก็บรวบรวม ใช้ หรือเปิดเผย “ผู้ควบคุมข้อมูลส่วนบุคคล” หมายถึง บุคคลหรือนิติบุคคลที่มีอํานาจในการตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล “ผู้ประมวลผลข้อมูลส่วนบุคคล” หมายถึง บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล ทั้งนี้ บุคคลหรือนิติบุคคลซึ่งดำเนินการดังกล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล “กลุ่มบริษัทกรุงเทพดุสิตเวชการ” หมายถึง บริษัทที่อยู่ในเครือข่ายของบริษัทกรุงเทพดุสิตเวชการ จำกัด (มหาชน) หรือ BDMS ทั้งที่มีอยู่ในปัจจุบันและที่จะมีขึ้นในอนาคตไม่ว่าจะจดทะเบียนในประเทศไทยหรือในต่างประเทศ
            </p>

            <div className="confirm-warp">
                <label htmlFor='confirm' className="top">
                    <input type="checkbox" id="confirm" onChange={onChange} /> 
                    <label htmlFor='confirm'>ฉันยอมรับข้อตกลงและเงื่อนไขของบริการ</label>
                </label>
                <div className="bottom">
                    <button 
                        className={checked ? "acitve" : "inactive"}
                        onClick={checked ? onSubmit : null}
                    >
                        ยอมรับ
                    </button>
                </div>
            </div> 

            <PageLoader/>
            <SignIn_Navbar canClose={true} />
        </div>
    )
}

export default SignIn_Policy